import {Flow} from 'flow-to-typescript-codemod';
// @ts-nocheck

import type {ExtensionMessage} from 'src/chat-extension/messages';

import * as React from 'react';

import nameHoc from 'src/flux/nameHoc';


const PortContext = React.createContext(null);
export default PortContext;

export const withPort = <Props extends Record<any, any>>(
  WrappedComponent: React.ComponentType<Props>,
): React.ComponentType<
  Flow.Diff<
    // @ts-expect-error - TS2344 - Type 'Props' does not satisfy the constraint '{ port: any; }'.
    Props,
    {
      // @ts-expect-error TS2503
      port: window.chrome.runtime.Port | null | undefined;
    }
  >
> =>
  nameHoc(
    (props) => (
      <PortContext.Consumer>
        {/* @ts-expect-error - TS2769 - No overload matches this call. | TS2698 - Spread types may only be created from object types. */}
        {(port) => <WrappedComponent {...props} port={port} />}
      </PortContext.Consumer>
    ),
    WrappedComponent,
    'withExtensionPort',
  );

class _PortComponent extends React.Component<{
  onMessage: (arg1: ExtensionMessage) => any;
  // @ts-expect-error TS2503
  port: window.chrome.runtime.Port | null | undefined;
}> {
  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<{ onMessage: (arg1: ExtensionMessage) => any; port: any; }, {}, any>'.
  componentDidMount() {
    this.listenToPort();
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<{ onMessage: (arg1: ExtensionMessage) => any; port: any; }, {}, any>'.
  componentWillUnmount() {
    this.forgetPort();
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<{ onMessage: (arg1: ExtensionMessage) => any; port: any; }, {}, any>'.
  componentDidUpdate(prevProps: unknown) {
    // @ts-expect-error - TS18046 - 'prevProps' is of type 'unknown'.
    if (prevProps.port && !this.props.port) {
      // @ts-expect-error - TS18046 - 'prevProps' is of type 'unknown'.
      this.forgetPort(prevProps.port);
      // @ts-expect-error - TS18046 - 'prevProps' is of type 'unknown'.
    } else if (!prevProps.port && this.props.port) {
      this.listenToPort();
    }
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<{ onMessage: (arg1: ExtensionMessage) => any; port: any; }, {}, any>'.
  render() {
    return null;
  }

  listenToPort() {
    this.props.port &&
      this.props.port.onMessage.addListener(this.handlePortMessage);
  }

  forgetPort(port = this.props.port) {
    port && port.onMessage.removeListener(this.handlePortMessage);
  }

  _handlePortMessage(message: ExtensionMessage) {
    this.props.onMessage(message);
  }
  handlePortMessage = this._handlePortMessage.bind(this);
}

export const PortComponent = withPort(_PortComponent);
